export class LoginCredentials {
    public email: string;
    public password: string;
    public rememberMe: boolean;
    public isApplication: boolean;
    public appVersion: string;
}
